import { all, takeEvery, put, call } from 'redux-saga/effects'
import { getListadoFirewallIps } from 'services/usuario'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'
// import history from '../../history'

export function* GET_FIREWALLIPS_ALL() {
  try {
    const firewallipData = yield call(getListadoFirewallIps)
    if (firewallipData.ok) {
      yield put({
        type: actions.FIREWALLIP_LOAD_SUCCEEDED,
        payload: firewallipData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar el firewall')
      put({
        type: actions.FIREWALLIP_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.FIREWALLIP_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.FIREWALLIP_LOAD_REQUESTED, GET_FIREWALLIPS_ALL)])
}
